import React from 'react';
import { withPrefix } from 'gatsby';
import { Title } from '../../Text/Title';
import { Divider } from '../../Divider';
import { DownloadButton } from '../../DownloadButton';
import styles from './HeroSection.styles';

const HeroSection = ({
  props: { title, subtitle, backgroundImage, mobileBackgroundImage, backgroundColorCard },
  report,
  textButton,
  downloadImg,
}) => (
  <div css={styles(backgroundColorCard)}>
    <div className="hero-section">
      <div className="hero-section__content">
        <Title text={title} fontSize={48} fontWeight={'bold'} lineHeight={53} maxWidth={'355px'} width={'100%'} />
        <Divider height={4} />
        <div className="hero-section__subtitle">{subtitle}</div>
        {report && (
          <DownloadButton
            downloadImg={downloadImg}
            textButton={textButton}
            report={report}
            className="download-button-top"
          />
        )}
      </div>
      <div className="hero-section-page__image-wrapper">
        {backgroundImage ? (
          <img src={withPrefix(backgroundImage)} className="hero-section__image" alt="heroImage" />
        ) : (
          <div className="plug-container" />
        )}
        {mobileBackgroundImage ? (
          <img src={withPrefix(mobileBackgroundImage)} className="hero-section__image--mobile" alt="heroImage" />
        ) : (
          <div className="plug-container-mobile" />
        )}
      </div>
    </div>
  </div>
);

export default HeroSection;
